import * as map from './modules/mapGetters'
import * as panorama from './modules/panoramaGetters'
import * as video from './modules/videoGetters'
import * as navigation from './modules/navigationGetters'
import * as tour from './modules/tourGetters'
import * as supplementalMedia from './modules/supplementalMediaGetters'
import * as analytics from './modules/analyticGetters'
import * as avatar from './modules/avatarGetters'
import * as stopDescription from './modules/stopDescriptionGetters'
import * as device from './modules/deviceGetters'

export default {
    panorama,
    video,
    map,
    navigation,
    tour,
    supplementalMedia,
    analytics,
    avatar,
    stopDescription,
    device,
}
